module.exports = __webpack_public_path__ + "static/media/checkmarkWhite.07dab023.svg";